export default "__VITE_ASSET__CZGHTtdp__"